import {Controller} from '@hotwired/stimulus';

export default class extends Controller {

    static targets = ['categoryCheckbox', 'news'];

    connect()
    {
        this.categoryCheckboxTargets.forEach(checkbox => {
            checkbox.addEventListener('click', () => {
                checkbox.querySelector('.w-checkbox-input--inputType-custom').classList.toggle('w--redirected-checked');
                checkbox.dataset.checkedStatus = checkbox.dataset.checkedStatus === "true" ? "false" : "true";
                this.newsTargets.forEach(actu => {
                    if (this.isActuCategoryDisplayed(actu.dataset.category))
                    {
                        actu.classList.remove('d-none');
                    }
                    else
                    {
                        actu.classList.add('d-none');
                    }
                })
            })
        })
    }

    isActuCategoryDisplayed(category)
    {
        return document.querySelector(`[data-category="${category}"]`).dataset.checkedStatus === "true" ;
    }
}
